import { ArrowUpOutlined } from '@ant-design/icons';
import {
  eatsUrl,
  verifiedSupportEmail,
  verifiedSupportPhone,
  verifiedSupportPhoneInternational
} from 'content/corporateContent';
import logo from 'images/Loggo.png';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const { pathname } = useLocation();
  const hiddenPath = pathname.includes('/user/')
    || pathname.startsWith('/admin/')
    || pathname.startsWith('/checkout/')
    || pathname.startsWith('/product/')
    || pathname.startsWith('/search/')
    || ['/shop', '/nfcprods', '/topselling'].includes(pathname);

  if (hiddenPath) return null;

  return (
    <footer className="corporate-footer">
      <div className="corporate-shell corporate-footer-top">
        <div className="corporate-footer-brand">
          <Link to="/" aria-label="Takka Smart home"><img alt="Takka Smart" src={logo} /></Link>
          <p>Smart business, branding, NFC, QR, profile, and restaurant-menu solutions.</p>
          <a href={`mailto:${verifiedSupportEmail}`}>{verifiedSupportEmail}</a>
          <a href={`tel:${verifiedSupportPhoneInternational}`}>{verifiedSupportPhone}</a>
        </div>
        <div className="corporate-footer-column">
          <h2>Solutions</h2>
          <Link to="/services/smart-stands">Smart stands</Link>
          <Link to="/services/digital-business-card">Digital business cards</Link>
          <Link to="/services/nfc-business-card">NFC business cards</Link>
          <Link to="/services/qr-solutions">QR solutions</Link>
          <Link to="/services/branding">Branding</Link>
        </div>
        <div className="corporate-footer-column">
          <h2>Company</h2>
          <Link to="/about">About</Link>
          <Link to="/work">Our work</Link>
          <Link to="/guides">Guides</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/signin">Client login</Link>
        </div>
        <div className="corporate-footer-column">
          <h2>Restaurant solutions</h2>
          <Link to="/services/digital-restaurant-menu">Digital restaurant menus</Link>
          <a href={eatsUrl} rel="noopener noreferrer" target="_blank">Open Takka Eats ↗</a>
          <h2 className="corporate-footer-legal-heading">Legal</h2>
          <Link to="/privacy-policy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/cookie-policy">Cookies</Link>
        </div>
      </div>
      <div className="corporate-shell corporate-footer-bottom">
        <p>© {new Date().getFullYear()} Takka Smart. All rights reserved.</p>
        <button aria-label="Back to top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} type="button">
          Back to top
          <ArrowUpOutlined aria-hidden="true" />
        </button>
      </div>
    </footer>
  );
};

export default Footer;
